export const ORGANIZATION_AUTOCOMPLETE = 'organization'
export const NAME_AUTOCOMPLETE = 'name'
export const FIRST_NAME_AUTOCOMPLETE = 'given-name'
export const LAST_NAME_AUTOCOMPLETE = 'family-name'
export const STREET_ADDRESS_AUTOCOMPLETE = 'street-address'
export const CITY_AUTOCOMPLETE = 'address-level2'
export const ZIP_CODE_AUTOCOMPLETE = 'postal-code'
export const PHONE_AUTOCOMPLETE = 'tel'
export const EMAIL_AUTOCOMPLETE = 'email'
export const PASSWORD_AUTOCOMPLETE = 'current-password'
export const PASSWORD_AUTOCOMPLETE_OFF = 'new-password'
export const MOVE_IN_DATE_AUTOCOMPLETE = 'move-in-date'
export const PHONE_EXTENSION_AUTOCOMPLETE = 'tel-extension'

export default {
	ORGANIZATION_AUTOCOMPLETE,
	NAME_AUTOCOMPLETE,
	STREET_ADDRESS_AUTOCOMPLETE,
	CITY_AUTOCOMPLETE,
	ZIP_CODE_AUTOCOMPLETE,
	PHONE_AUTOCOMPLETE,
	EMAIL_AUTOCOMPLETE,
	FIRST_NAME_AUTOCOMPLETE,
	LAST_NAME_AUTOCOMPLETE,
	PASSWORD_AUTOCOMPLETE,
	PASSWORD_AUTOCOMPLETE_OFF,
	MOVE_IN_DATE_AUTOCOMPLETE
}
